export default "__VITE_ASSET__BF_eoyyb__"